import { ContainerPositionType, JobDto, WorkInstructionWarningReason } from '@operations/app/api'
import { observer } from 'mobx-react-lite'
import { DoorDirectionInfo } from '../JobInformation/DoorDirectionInfo'
import { JobInformationJourney } from '../JobInformation/JobInformationJourney'
import { JobInformationOperationalInstructions } from '../JobInformation/JobInformationOperationalInstructions'
import { JobInformationWrapper } from '../JobInformation/JobInformationWrapper'
import { ConfirmPicks } from './ConfirmPicks'
import { ConfirmPickUpProps } from './confirm-pickup.interface'

interface Props {
  job: JobDto
  jobWarningReason?: WorkInstructionWarningReason
  stepsTotal?: number
  currentStep?: number
  handlePicks?: (id: string) => void
  DestinationComponent?: React.ComponentType<ConfirmPickUpProps>
  showDoorDirectIfExists?: boolean
}
export const CheckInformation = observer(
  ({
    job,
    jobWarningReason,
    stepsTotal,
    currentStep,
    handlePicks,
    DestinationComponent,
    showDoorDirectIfExists,
  }: Props) => {
    return (
      <JobInformationWrapper
        job={job}
        currentStep={currentStep}
        stepsTotal={stepsTotal}
        jobWarningReason={jobWarningReason}
      >
        {(!currentStep || currentStep === 1) && <JobInformationOperationalInstructions job={job} />}

        <JobInformationJourney job={job} />
        {showDoorDirectIfExists && <DoorDirectionInfo job={job} />}
        {job.from.type === ContainerPositionType.Yard && (
          <ConfirmPicks
            handlePicks={handlePicks}
            DestinationComponent={DestinationComponent}
            containerNumber={job.cargoUnit?.displayName ?? ''}
          />
        )}
      </JobInformationWrapper>
    )
  },
)
